// import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';

import './DiamondDetails.style';
import DiamondcolorIcon from 'Component/DiamondcolorIcon';
import DiamondclarityIcon from 'Component/DiamondclarityIcon';
import DiamondcutIcon from 'Component/DiamondcutIcon';
import DiamondClarity from 'Component/DiamondClarity';
import DiamondCut from 'Component/DiamondCut';
import DiamondColor from 'Component/DiamondColor';
import { color_diamonds } from 'Src/Value/ColorDiamond_color';

export class DiamondDetails extends PureComponent {
    static propTypes = {
        diamond: this.propTypes
    };

    renderDiamondColorInformation = (diamond_color, girdle_max, hasColor) => {
        if (!diamond_color) {
            return null;
        }

        return (
            <div className='DiamondDetails-InnerInformationContainer'>
                <div className='DiamondDetails-InformationHeader'>
                    <DiamondcolorIcon />
                    <span>color : {hasColor ? color_diamonds[diamond_color?.toLowerCase()] : diamond_color}</span>
                </div>

                <div className='DiamondDetails-Content'>
                    <DiamondColor diamond_color={diamond_color} girdle_max={girdle_max} />
                </div>

                <p>Color refers to the natural tint of a diamond. The closer the diamond is to “colorless” the rarer it is. The industry standard to grading color in a diamond is to assign a letter grade from D (colorless) to J (nearly colorless)</p>
            </div>
        )
    }

    renderDiamondClarityInformation = (diamond_clarity) => {
        if (!diamond_clarity) {
            return null;
        }

        return (
            <div className='DiamondDetails-InnerInformationContainer'>
                <div className='DiamondDetails-InformationHeader'>
                    <DiamondclarityIcon />
                    <span>Clarity : {diamond_clarity}</span>
                </div>

                <div className='DiamondDetails-Content'>
                    <DiamondClarity diamond_clarity={diamond_clarity} />
                </div>

                <p>Most diamonds have imperfections in the form of internal flaws and surface blemishes. These imperfections are graded on a scale of FL (flawless) to I1-I3 (included). FL diamonds are the rarest and hardest to find.</p>
            </div>
        )
    }

    renderDiamondCutInformation = (diamond_cut) => {
        if (!diamond_cut) {
            return null;
        }

        const diamond_cuts = ["excellent", "very good", "good"];

        if (!diamond_cuts?.includes(diamond_cut?.toLowerCase())) {
            return false;
        }

        return (
            <div className='DiamondDetails-InnerInformationContainer'>
                <div className='DiamondDetails-InformationHeader'>
                    <DiamondcutIcon />
                    <span>Cut : {diamond_cut}</span>
                </div>

                <div className='DiamondDetails-Content'>
                    <DiamondCut diamond_cut={diamond_cut} />
                </div>

                <p>A diamond’s cut measures its anatomy and ability to reflect light. Cut grades go from “Excellent” to “Poor”. Well-cut diamonds have outstanding proportions with immense fire, brilliance, and scintillation.</p>
            </div>
        )
    }

    render() {
        const {
            diamond
        } = this.props;

        if (diamond?.length <= 0) {
            return null;
        }

        const diamond_data = diamond[0];

        return (
            <div className='Diamonddetails-Container'>
                <h1 className='Diamonddetails-Heading'>Understand Your Diamond Qualities</h1>

                <div className='Diamonddetails-InformationContainer'>
                    {this.renderDiamondColorInformation(diamond_data?.diamond_color, diamond_data?.girdle_max, diamond_data?.hasColor)}
                    {this.renderDiamondClarityInformation(diamond_data?.diamond_clarity)}
                    {this.renderDiamondCutInformation(diamond_data?.diamond_cut)}
                </div>
            </div>
        );
    }
}

export default DiamondDetails;
